export default {
  label: {
    title: 'Integraciones',
    description: 'Token de integración',
  },
};
